import React from "react";
import ReactDOM from "react-dom/client";

import moment from "moment";
import "moment/locale/de";
import "bootstrap/js/dist/modal";

import { SnowflakeAnmimation, Search } from "./layout";
import { WindowBlock } from "./blocks";

import renderCustomPages from "./pages";

import { EventsPreview } from "./pages/home"

import { useIsAuthenticated } from "./providers/content";

import "./bs.scss";
import "./app.scss";
import "./fa";

// Relict, keep included
import "./gutenberg/style.scss";

const renderSearchBlock = () => {
  const blockRoots = document.querySelectorAll(".mebm-search-block");

  blockRoots.forEach(blockRoot => {
    const postTypes = (blockRoot.dataset.postTypes || "")
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s);
    const previewResultsRaw = parseInt(blockRoot.dataset.previewResults, 10);
    const previewResults = isNaN(previewResultsRaw) ? 3 : previewResultsRaw;
    const initialSearchString = blockRoot.dataset.initialSearchString || "";

    ReactDOM.createRoot(blockRoot).render(
      <Search  
        searchPage
        fixedPostTypes={postTypes} 
        numPreviewResults={previewResults} 
        initialSearchString={initialSearchString}
      />
    );
  });
};

const renderSearchPage = () => {
  const root = document.getElementById("search-root");
  root && ReactDOM.createRoot(root).render(<Search searchPage urlState />);
};

const renderSearchHeader = () => {
  const root = document.getElementById("header-search-root");
  root && ReactDOM.createRoot(root).render(<Search />);
};


const renderSnowflakes = () => {
  const root = document.getElementById("snowflake-animation-root");
  root && ReactDOM.createRoot(root).render(<SnowflakeAnmimation />);
}


const renderEventsPreview = () => {
  const root = document.getElementById("events-preview-root");
  root && ReactDOM.createRoot(root).render(<EventsPreview />);
}



const render = () => {
  renderCustomPages();
  renderSearchPage();
  renderSearchHeader();
  renderSearchBlock();
  renderSnowflakes();
  renderEventsPreview();
};

render();
